import axios from './axios'
import config from '../config'
function uploadFile (file, params) {
    var formData = new FormData()
    formData.append('file', file)
    if (params) {
        for (const name in params) {
            formData.append(name, params[name])
        }
    }
    return axios({
        url: config.backendUrl + '/files',
        method: 'POST',
        data: formData
    })
}
function getFileUrl(file){
    return config.backendUrl + '/files?path=' + encodeURIComponent(file.path)
}
function downloadFile(file){
    window.open(getFileUrl(file), '_blank')
}
function getDpsFileUrl(name){
    return config.backendUrl + '/dps-files/' + encodeURIComponent(name)
}
export default {
    uploadFile,
    downloadFile,
    getFileUrl,
    getDpsFileUrl
}
